// extracted by mini-css-extract-plugin
module.exports = {"conversionRateTable":"conversionRateTable_conversionRateTable__kK3YT"};